/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtCreatePosition = {
  pool: Address;
  owner: Address;
  position: Address;
  positionNftMint: Address;
};

export type EvtCreatePositionArgs = EvtCreatePosition;

export function getEvtCreatePositionEncoder(): FixedSizeEncoder<EvtCreatePositionArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["positionNftMint", getAddressEncoder()],
  ]);
}

export function getEvtCreatePositionDecoder(): FixedSizeDecoder<EvtCreatePosition> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["positionNftMint", getAddressDecoder()],
  ]);
}

export function getEvtCreatePositionCodec(): FixedSizeCodec<
  EvtCreatePositionArgs,
  EvtCreatePosition
> {
  return combineCodec(
    getEvtCreatePositionEncoder(),
    getEvtCreatePositionDecoder(),
  );
}
